import { reactive } from 'vue';

export const requestState = reactive({ pending: 0, error: '' });
